module.exports = __webpack_public_path__ + "img/nocontent.f56e65a4.svg";